import React from 'react'
import { useTheme } from 'styled-components'
import {
  AttachmentContainer,
  TitleWrapper,
  IconWrapper,
  ActionWrapper,
  AttachmentSize
} from './Attachment.styles'
import { TrackTitle } from '../Track/Track.styles'
import { MaterialIcon } from '@dsny/dsny-component-library'
import { handleAttachmentDownload } from '../../utils'
import useReleaseInformationResponsiveBreakpointsV2 from '../../hooks/useReleaseInformationResponsiveBreakpointsV2'

export default function Attachment({ attachment = {} }) {
  const theme = useTheme()
  const responsiveBreakpointsV2 = useReleaseInformationResponsiveBreakpointsV2()
  const sizeInMB = (attachment?.size / 1048576).toFixed(3)
  const downloadAttachment = () => handleAttachmentDownload(attachment?.url)

  return (
    <AttachmentContainer $responsiveBreakpointsV2={responsiveBreakpointsV2}>
      <IconWrapper>
        <MaterialIcon name="Document" color={theme.colors.player50} />
      </IconWrapper>
      <TitleWrapper $responsiveBreakpointsV2={responsiveBreakpointsV2}>
        <TrackTitle className="truncate-text">{attachment?.title}</TrackTitle>
        <AttachmentSize>{`${sizeInMB} MB`}</AttachmentSize>
      </TitleWrapper>

      <ActionWrapper
        type="button"
        aria-label={`Download ${attachment?.title || 'attachment'}`}
        onClick={downloadAttachment}
      >
        <MaterialIcon name="FileDownload" color={theme.colors.neutralW100} />
      </ActionWrapper>
    </AttachmentContainer>
  )
}
